import { CLINICAL_SUPERVISORS, USERS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { AssignBCBAsProperties, AssignClinicalSupervisorProperties } from '../userAPIProperties';

export const ClinicalSupervisor = {
	getClinicalSupervisorsTherapists: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${CLINICAL_SUPERVISORS}/${userId}/therapists`,
		}),
	getClinicalSupervisorsBCBAs: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${CLINICAL_SUPERVISORS}/${userId}/bcbas`,
		}),
	getBCBAClinicalSupervisors: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/bcbas/${userId}/clinical-supervisors`,
		}),
	assignClinicalSupervisors: (data: AssignClinicalSupervisorProperties) =>
		FetchAPI.postJson({
			urlStr: `${USERS}/bcbas/${data.userId}/clinical-supervisors`,
			data,
		}),
	assignBCBAs: (data: AssignBCBAsProperties) =>
		FetchAPI.postJson({
			urlStr: `${USERS}/clinical-supervisors/${data.clinicalSupervisorId}/bcbas`,
			data,
		}),
};
